import { createFileRoute } from '@tanstack/react-router';
import { enum as zodEnum, object as zodObject } from 'zod';
import { WhatsOnListPage } from '../../../features/whats-on/routes/WhatsOnListPage';

const tokenSearchSchema = zodObject({
    type: zodEnum(['appointment', 'event']).optional(),
});

export const Route = createFileRoute('/whats-on/$token/')({
    component: WhatsOnListPage,
    validateSearch: search => tokenSearchSchema.parse(search),
});
